// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const spiritomb: PokeData = {
  "id": 442,
  "name": "spiritomb",
  "height": 10,
  "weight": 1080,
  "base_experience": 170,
  "types": [
    PokeType.GHOST,
    PokeType.DARK
  ],
  "api_moves": [
    "hypnosis",
    "night-shade",
    "confuse-ray",
    "dream-eater",
    "curse",
    "spite",
    "feint-attack",
    "pursuit",
    "shadow-ball",
    "memento",
    "extrasensory",
    "payback",
    "sucker-punch",
    "dark-pulse",
    "nasty-plot",
    "shadow-sneak",
    "ominous-wind",
    "hex"
  ],
  "moves": [
    "night-shade",
    "confuse-ray",
    "curse",
    "pursuit",
    "shadow-ball",
    "dark-pulse",
    "shadow-sneak",
    "lick",
    "spectral-chain",
    "snatch",
    "spectral-snatch",
    "soul-sacrifice",
    "night-slash"
  ],
  "evolution_chain": {
    "id": 229,
    "item": null,
    "species": [
      {
        "name": "spiritomb",
        "order": 463,
        "types": [
          PokeType.GHOST,
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 153,
    "speed": 68,
    "ability_power": 179
  },
  "stat_changes": [],
  "catch_rate": 100,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
